import "./index.sass";

interface ExtraDescriptionProps {
  text: string;
}

const ExtraDescription: React.FC<ExtraDescriptionProps> = ({ text }) => {
  const formattedText = text.replace(/\n/g, "<br />");
  return (
    <div className="extra-description">
      <div dangerouslySetInnerHTML={{ __html: formattedText }} />
    </div>
  );
};

export default ExtraDescription;
